export const category=[
  {
    "img": "https://images-static.nykaa.com/uploads/1216b52d-9ce4-4509-a477-d91befba4df1.jpg?tr=w-150,cm-pad_resize",
    "offer": "Makeup"
  },
  {
    "img": "https://images-static.nykaa.com/uploads/8b0cbc2d-e429-4544-a497-649dc18dddda.jpg?tr=w-150,cm-pad_resize",
    "offer": "Skincare"
  },
  {
    "img": "https://images-static.nykaa.com/uploads/8b9aee6b-eac3-4b75-9ca3-0b2db94604ea.jpg?tr=w-150,cm-pad_resize",
    "offer": "Hair"
  },
  {
    "img": "https://images-static.nykaa.com/uploads/7d56864e-f60c-40f6-b774-b70f7023c709.jpg?tr=w-150,cm-pad_resize",
    "offer": "Bath & Body"
  },
  {
    "img": "https://images-static.nykaa.com/uploads/a04697ab-5aa1-4d3d-9cde-da35baa244ca.jpg?tr=w-150,cm-pad_resize",
    "offer": "Fragrance"
  },
  {
    "img": "https://images-static.nykaa.com/uploads/dad4155c-774c-4eed-835a-55a88f3b6676.jpg?tr=w-150,cm-pad_resize",
    "offer": "Luxe"
  },
  {
    "img": "https://images-static.nykaa.com/uploads/bf3bc862-fcc6-49e9-a7c4-02fa5cfffa51.jpg?tr=w-150,cm-pad_resize",
    "offer": "Wellness"
  },
  {
    "img": "https://images-static.nykaa.com/uploads/b4e1ca2f-f0d5-4c7d-b62c-d6ac47b2fa6d.jpg?tr=w-150,cm-pad_resize",
    "offer": "Appliances"
  }
]
export const topBrands=[
    {
        img:"https://images-static.nykaa.com/creatives/9188840e-a5da-4599-8d29-1c479bfa8c2f/default.jpg?tr=w-400,cm-pad_resize",
        name:"Nykaa",
        offer:"Upto 35% Off"
        ,description:"Free Lipstick on ₹799"
    },  {
        img:"https://images-static.nykaa.com/creatives/a07ab0e1-4a06-4321-80c0-88a781095e72/default.jpg?tr=w-400,cm-pad_resize",
        name:"Elle18",
        offer:"Makeup@55"
        ,description:"Lipstick on ₹249"
    },
    {
        img:"https://images-static.nykaa.com/creatives/492fd8de-0d6c-4102-bdf1-8d64353ade88/default.png?tr=w-400,cm-pad_resize",
        name:"KayBeauty",
        offer:"Anniversary Special Drop!",
        description:" Rest of Brand: Upto 20% Off "
    },
    {
        img:"https://images-static.nykaa.com/creatives/095d470d-08c5-4489-8463-b830948d516d/default.jpg?tr=w-400,cm-pad_resize",
        name:"Maybelline",
        offer:"Anniversary Special Drop!"
        ,description:"Rest of Brand: Upto 20% Off"
    },  {
        img:"https://images-static.nykaa.com/creatives/6dff395e-6d24-41dd-a770-8fb9da0062ad/default.jpg?tr=w-400,cm-pad_resize",
        name:"Loreal",
        offer:"Upto 30% Off"
        ,description:"Additional 10% Off On ₹1299+"
    },
    {
        img:"https://images-static.nykaa.com/creatives/bfffdd76-d5b2-4a3b-9d24-9cbe93b35f21/default.jpg?tr=w-400,cm-pad_resize",
        name:"Garnier",
        offer:"Upto 30% Off"
        ,description:"Great Deals On Combos"
    },
    {
        img:"https://images-static.nykaa.com/creatives/8cf2c7c2-15af-4a5c-a899-71660863d36c/default.jpg?tr=w-400,cm-pad_resize",
        name:"Minimalist",
        offer:"Flat 5% Off"
        ,description:" On Entire Range"
    },
]
export const justDropped=[
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/maybelline-volum-express-hyper-curl-mascara/p/809?productId=809&skuId=808&pps=1",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/e/8/e8524d069234925874430_1.jpg",
      "name": "Maybelline New York Volum Express Hyper Curl Mascara - Washa...",
      "price": "₹322",
      "offer": "Extra 10% Off",
      "qty": "( 74931 )",
      "best": "",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/m-a-c-studio-fix-fluid-spf-15/p/88999?productId=88999&pps=2",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/c/9/c9e05ed773602103485_1.jpg",
      "name": "M.A.C Studio Fix Fluid SPF 15",
      "price": "₹3600",
      "offer": "Enjoy Free Gift",
      "qty": "( 9830 )",
      "best": "BESTSELLER",
      "shades": "51 shades"
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/aqualogica-glow-dewy-sunscreen-with-papaya-vitamin-c/p/10593377?productId=10593377&skuId=5009759&pps=3",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/5/4/5440bc8AQUAA00000021_1.jpg",
      "name": "Aqualogica Glow+ Dewy Sunscreen with Papaya & Vitamin C - SP...",
      "price": "₹343",
      "offer": "Enjoy Free Gift",
      "qty": "( 31094 )",
      "best": "",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/sugar-contour-de-force-face-palette/p/244239?productId=244239&pps=4",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/1/9/19b50528906090492256_01.jpg",
      "name": "SUGAR Contour De Force Face Palette",
      "price": "₹695",
      "offer": "",
      "qty": "( 14054 )",
      "best": "BESTSELLER",
      "shades": "3 shades"
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/l-oreal-paris-revitalift-1-5-hyaluronic-acid-serum/p/1112060?productId=1112060&skuId=1112054&pps=5",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/f/5/f59482cLOREA00000003_1.jpg",
      "name": "L'Oreal Paris Revitalift Hydrating Serum With 1.5 % Hyaluron...",
      "price": "₹424",
      "offer": "Extra 10% Off",
      "qty": "( 25645 )",
      "best": "",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/l-oreal-professionnel-x-tenso-care-shampoo/p/10500?productId=10500&pps=6",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/f/8/f85bae18901526403868_z1.jpg",
      "name": "L'Oreal Professionnel X-Tenso Care Shampoo For Smooth, Manag...",
      "price": "₹650",
      "offer": "",
      "qty": "( 19838 )",
      "best": "BESTSELLER",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/nykaa-cosmetics-all-day-matte-waterproof-transfer-proof-mask-proof-12h-liquid-lipstick/p/2790711?productId=2790711&pps=7",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/0/0/0053420NYKAC00000072_1new.jpg",
      "name": "Nykaa Cosmetics All Day Matte Waterproof, Transfer Proof, 12...",
      "price": "₹239",
      "offer": "Enjoy Free Gift",
      "qty": "( 25860 )",
      "best": "BESTSELLER",
      "shades": "19 shades"
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/lakme-absolute-primer/p/12910650?productId=12910650&skuId=44942&pps=8",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/8/2807eca23657_H_8901030824999.jpg",
      "name": "Lakme Absolute Blur Perfect Makeup Primer",
      "price": "₹495",
      "offer": "Get Free Product",
      "qty": "( 894 )",
      "best": "",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/wella-professionals-elements-renewing-shampoo/p/70562?productId=70562&pps=9",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/c/4/c4489004064666036267_1.jpg",
      "name": "Wella Professionals Elements Renewing Shampoo (Zero Sulfates...",
      "price": "₹1035",
      "offer": "Offer Available",
      "qty": "( 2151 )",
      "best": "BESTSELLER",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/mamaearth-onion-hair-mask-for-dry-frizzy-hair-200ml/p/513089?productId=513089&pps=10",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/e/d/edbb16c8906087771685.jpg",
      "name": "Mamaearth Onion Hair Mask For Hair Fall Control",
      "price": "₹527",
      "offer": "Get Free Product",
      "qty": "( 5838 )",
      "best": "BESTSELLER",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/minimalist-spf-60-pa-face-sunscreen-with-antioxidant-silymarin-for-complete-sun-protection/p/2812175?productId=2812175&pps=11",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/1/8/18d33a4MINIM00000028_1509231.jpg",
      "name": "Minimalist SPF 60 PA ++++ Sunscreen With Antioxidant Silymar...",
      "price": "₹569",
      "offer": "",
      "qty": "( 4152 )",
      "best": "BESTSELLER",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/plum-bodylovin-vanilla-vibes-body-oil/p/10357956?productId=10357956&skuId=5020970&pps=12",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/a/b/abe301bPLUMX00000283_01.jpg",
      "name": "Plum Bodylovin' Vanilla Vibes Body Oil",
      "price": "₹239",
      "offer": "",
      "qty": "( 6023 )",
      "best": "",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/kiehl-s-creamy-eye-treatment-with-avocado/p/26492?productId=26492&pps=13",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/e/5/e5d865e3700194714413_1.jpg",
      "name": "Kiehl's Creamy Eye Treatment With Avocado, Shea Butter & Bet...",
      "price": "₹2650",
      "offer": "Enjoy Free Gift",
      "qty": "( 516 )",
      "best": "BESTSELLER",
      "shades": ""
    },
    {
      "custom-tag": "FEATURED",
      "href": "https://www.nykaa.com/tonymoly-i-m-mask-sheet/p/464329?productId=464329&pps=14",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/c/b/cb20ea48806194022857_1.jpg",
      "name": "TONYMOLY I'M Mask Sheet",
      "price": "₹100",
      "offer": "Buy 5 at MRP, Get 5 Free",
      "qty": "( 49845 )",
      "best": "BESTSELLER",
      "shades": "11 shades"
    },
    {
      "custom-tag": "",
      "href": "https://www.nykaa.com/cetaphil-cleansing-lotion/p/22032?productId=22032&pps=15",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/1/8/18d33a4NYCETA0000010_1509231.jpg",
      "name": "Cetaphil Gentle Skin Cleanser",
      "price": "₹276",
      "offer": "",
      "qty": "( 85760 )",
      "best": "BESTSELLER",
      "shades": "4 sizes"
    },
    {
      "custom-tag": "",
      "href": "https://www.nykaa.com/cosrx-advanced-snail-96-mucin-power-essence/p/757628?productId=757628&pps=16",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/a/8/a8468fe8809416470009_1n.jpg",
      "name": "COSRX Advanced Snail 96 Mucin Power Essence",
      "price": "₹1233",
      "offer": "",
      "qty": "( 15829 )",
      "best": "",
      "shades": ""
    },
    {
      "custom-tag": "",
      "href": "https://www.nykaa.com/nykaa-skin-secrets-sheet-mask/p/418274?productId=418274&pps=17",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/3/8/389e50f8904245712280_1.jpg",
      "name": "Nykaa Naturals Skin Secrets Exotic Indulgence Sheet Mask",
      "price": "₹80",
      "offer": "Or Buy 5 at MRP, Get 5 Free",
      "qty": "( 199787 )",
      "best": "",
      "shades": "13 shades"
    },
    {
      "custom-tag": "",
      "href": "https://www.nykaa.com/the-ordinary-niacinamide-10percent-zinc-1percent/p/5003164?productId=5003164&pps=18",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/2/226647aTHECI00000026.jpg",
      "name": "The Ordinary Niacinamide 10% + Zinc 1%",
      "price": "₹550",
      "offer": "",
      "qty": "( 22072 )",
      "best": "",
      "shades": ""
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/1/8/18d33a4NYCETA0000010_1509231.jpg",
      "name": "Cetaphil Gentle Skin Cleanser |Dry to Normal Skin with Niaci...",
      "mrp": "₹333",
      "price": "₹300",
      "offer": "10% Off",
      "qty": "( 86267 )",
      "gift": "",
      "shades": ""
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/5/4/5440bc8AQUAA00000021_1.jpg",
      "name": "Aqualogica Glow + Dewy Sunscreen With Papaya & Vitamin C",
      "mrp": "₹399",
      "price": "₹355",
      "offer": "11% Off",
      "qty": "( 31488 )",
      "gift": "Enjoy Free Gift",
      "shades": "2 sizes"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/9/b/9b6fba927473_H-8901030883255.jpg",
      "name": "Ponds Super Light Gel Oil Free Moisturiser With Hyaluronic A...",
      "mrp": "₹440",
      "price": "₹374",
      "offer": "15% Off",
      "qty": "( 123004 )",
      "gift": "Extra 10% Off",
      "shades": "3 sizes"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/4/f/4f5a52cTHEDE00000076_1.jpg",
      "name": "The Derma Co. 1% Hyaluronic Sunscreen Aqua Gel SPF 50",
      "mrp": "₹499",
      "price": "₹464",
      "offer": "7% Off",
      "qty": "( 23437 )",
      "gift": "",
      "shades": "2 sizes"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/a/2/a2055cd41554496918_1.jpg",
      "name": "Maybelline New York Super Stay Matte Ink Liquid Lipstick",
      "mrp": "₹699",
      "price": "₹455",
      "offer": "35% Off",
      "qty": "( 74315 )",
      "gift": "",
      "shades": "20 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/0/0/0076e1eMAYBE00000020_1.jpg",
      "name": "Maybelline New York Fit Me 12Hr Oil Control Compact",
      "mrp": "₹259",
      "price": "₹220",
      "offer": "15% Off",
      "qty": "( 66408 )",
      "gift": "",
      "shades": "6 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/8/2807eca24551_H_8901030758942.jpg",
      "name": "Lakme Forever Matte Liquid Lip Color",
      "mrp": "₹349",
      "price": "₹314",
      "offer": "10% Off",
      "qty": "( 75522 )",
      "gift": "",
      "shades": "50 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/5/5/555cfc48904245705107_1.jpg",
      "name": "Nykaa Cosmetics Matte To Last ! Liquid Lipstick",
      "mrp": "₹675",
      "price": "₹439",
      "offer": "35% Off",
      "qty": "( 46837 )",
      "gift": "Enjoy Free Gift",
      "shades": "24 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/c/4/c4b596e8901012185292_01U.jpg",
      "name": "Neutrogena UltraSheer Dry Touch Sunblock SPF 50+",
      "mrp": "",
      "price": "₹260",
      "offer": "",
      "qty": "( 94203 )",
      "gift": "",
      "shades": "2 sizes"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/8/d/8d9e9d86902395722434_1.jpg",
      "name": "Maybelline New York Fit Me Matte+Poreless Liquid Foundation ...",
      "mrp": "₹325",
      "price": "₹257",
      "offer": "21% Off",
      "qty": "( 75754 )",
      "gift": "",
      "shades": "6 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/f/5/f507df06923700970449_1.jpg",
      "name": "L'Oreal Paris Extraordinary Oil Hair Serum, Anti-Frizz Serum...",
      "mrp": "₹649",
      "price": "₹552",
      "offer": "15% Off",
      "qty": "( 35663 )",
      "gift": "",
      "shades": "2 sizes"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/2/226647aTHECI00000030.jpg",
      "name": "The Ordinary Glycolic Acid 7% Toning Solution",
      "mrp": "",
      "price": "₹1250",
      "offer": "",
      "qty": "( 10140 )",
      "gift": "",
      "shades": ""
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/b/c/bc1607aPLUMX00000068_1507231.jpg",
      "name": "Plum 15% Vitamin C Face Serum with Mandarin for Glowing Skin...",
      "mrp": "₹790",
      "price": "₹672",
      "offer": "15% Off",
      "qty": "( 35516 )",
      "gift": "",
      "shades": "3 sizes"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/0/4/04a1af76902395487432_1.jpg",
      "name": "Maybelline New York Instant Age Rewind Eraser Dark Circles T...",
      "mrp": "₹729",
      "price": "₹549",
      "offer": "25% Off",
      "qty": "( 43800 )",
      "gift": "",
      "shades": "9 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/1/8/18d33a4MINIM00000001_1509231.jpg",
      "name": "Minimalist 10% Niacinamide Face Serum With Matmarine + Zinc ...",
      "mrp": "",
      "price": "₹599",
      "offer": "",
      "qty": "( 28171 )",
      "gift": "",
      "shades": ""
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/c/5/c52172a8904245704858_1.jpg",
      "name": "Nykaa Naturals Skin Secrets Indian Rituals Sheet Mask",
      "mrp": "₹100",
      "price": "₹80",
      "offer": "20% Off",
      "qty": "( 41517 )",
      "gift": "Or Buy 5 at MRP, Get 5 Free",
      "shades": "11 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/1/8/18d33a4NYCETA0000007_1509231.jpg",
      "name": "Cetaphil Moisturising Lotion For Dry To Normal Sensitive Ski...",
      "mrp": "₹486",
      "price": "₹437",
      "offer": "10% Off",
      "qty": "( 19440 )",
      "gift": "",
      "shades": "3 sizes"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/8/2807eca24859_H_8901030794773.jpg",
      "name": "Lakme 9 To 5 Primer + Matte Lipstick",
      "mrp": "₹550",
      "price": "₹468",
      "offer": "15% Off",
      "qty": "( 35125 )",
      "gift": "",
      "shades": "35 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/e/6/e6d65cd41554453645_1.jpg",
      "name": "Maybelline New York Color Sensational Creamy Matte Lipstick",
      "mrp": "₹329",
      "price": "₹263",
      "offer": "20% Off",
      "qty": "( 108900 )",
      "gift": "",
      "shades": "20 shades"
    },
    {
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/4/f/4f5a52cTHEDE00000076_1.jpg",
      "name": "The Derma Co 1% Hyaluronic Sunscreen Aqua Gel With Spf 50 Pa...",
      "mrp": "₹499",
      "price": "₹464",
      "offer": "7% Off",
      "qty": "( 23437 )",
      "gift": "",
      "shades": ""
    }
  ]


  export const actualJustDropped=[
    {
      "name": "Nykaa Festive '23 Glitter Nail Enamel",
      "shades": "8 Shades",
      "price": "₹249",
      "rating": "",
      "ratingcount": ""
      ,'img':"https://images-static.nykaa.com/media/catalog/product/tr:h-800,w-800,cm-pad_resize/0/8/08e541fNYKAC00001797_1.png"
    },
    {
      "name": "Daily Life Forever52 Coverup Foundation",
      "shades": "15 Shades",
      "price": "₹1699",
      "rating": "",
      "ratingcount": "",
      'img':"https://images-static.nykaa.com/media/catalog/product/tr:h-800,w-800,cm-pad_resize/4/9/49aa6f63592499841013_1.png"
    },
    {
      "name": "Cetaphil Hydrating Foaming Cream Cleanser for All skin types with Niacinamide and Aloevera",
      "shades": "236ml",
      "price": "₹712",
      "rating": "5.0★",
      "ratingcount": "/5  (4)",
      'img':"https://images-static.nykaa.com/media/catalog/product/f/c/fc573a5CETAP00000097_2709231.jpg"
    },
    {
      "name": "Cetaphil Brightening Serum with Antioxidant C & Advanced Peptide",
      "shades": "30ml",
      "price": "₹1954",
      "rating": "5.0★",
      "ratingcount": "/5  (1)",
      'img':"https://images-static.nykaa.com/media/catalog/product/8/d/8da7f91CETAP00000098_0610231.jpg"
    },
    {
      "name": "The Derma Co 2% Niacinamide High Coverage Foundation With 1% HA Complex & SPF 40 PA+++",
      "shades": "7 Shades",
      "price": "₹809",
      "rating": "5.0★",
      "ratingcount": "/5  (41)",
      'img':"https://images-static.nykaa.com/media/catalog/product/tr:h-800,w-800,cm-pad_resize/d/0/d0dd53f8904417308891_1.jpg"
    },
    {
      "name": "Lakme Glitterati Collection Shine Eyeliner",
      "shades": "5 Shades",
      "price": "₹440",
      "rating": "",
      "ratingcount": "",
      'img':"https://images-static.nykaa.com/media/catalog/product/tr:h-800,w-800,cm-pad_resize/9/d/9d846d129657_H-8901030973727.jpg"
    },
    {
      "name": "FAE Beauty Lip Whip 8H Matte Liquid Lipstick",
      "shades": "10 Shades",
      "price": "₹585",
      "rating": "4.7★",
      "ratingcount": "/5  (10)",
      'img':"https://images-static.nykaa.com/media/catalog/product/tr:h-800,w-800,cm-pad_resize/3/e/3e5f656FAEBE00000102_1.jpg"
    },
    {
      "name": "Benefit Cosmetics Big Festive Love Kit",
      "shades": "3 pcs",
      "price": "₹3000",
      "rating": "",
      "ratingcount": "",
      'img':"https://images-static.nykaa.com/media/catalog/product/6/4/6440486BENEF00000484_1.jpg"
    },
    {
      "name": "Renee Cosmetics Glam Stack 3 In 1 Lip & Cheek Tint",
      "shades": "2 Shades",
      "price": "₹495",
      "rating": "",
      "ratingcount": "",
      'img':"https://images-static.nykaa.com/media/catalog/product/tr:h-800,w-800,cm-pad_resize/6/4/64330f08906121646597_1.jpg"
    },
    {
      "name": "Lakme Glitterati Collection Shine Lipstick",
      "shades": "10 Shades",
      "price": "₹520",
      "rating": "",
      "ratingcount": "",
      'img':"https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/a/b/abe301bPLUMX00000283_01.jpg"
    },
    
  ]

  export const radar=[
    {
      "img": "https://images-static.nykaa.com/creatives/76e5a811-eb07-4534-86cc-16961c7a673a/default.jpg?tr=w-240,cm-pad_resize",
      "offer": "Upto 20% Off",
      "description": "On Entire Range"
    },
    {
      "img": "https://images-static.nykaa.com/creatives/7f515b8a-5e67-4191-813f-f23f2175ef17/default.jpg?tr=w-240,cm-pad_resize",
      "offer": "Upto 40% Off",
      "description": "On Bestsellers"
    },
    {
      "img": "https://images-static.nykaa.com/creatives/5c34b38b-bba7-46f7-a844-999561f3bdf2/default.jpg?tr=w-240,cm-pad_resize",
      "offer": "Flat 10% Off +",
      "description": "B5G5 On Sheet Masks"
    },
    {
      "img": "https://images-static.nykaa.com/creatives/ab3586a7-b4d0-4f00-b63f-1ccbebfc259e/default.jpg?tr=w-240,cm-pad_resize",
      "offer": "Upto 30% Off",
      "description": "On Entire Range",
      'link':"/nykaaNaturals"
    },
    {
      "img": "https://images-static.nykaa.com/creatives/49e5af2e-62a0-4078-873c-6e1cfa1fd4a8/default.jpg?tr=w-240,cm-pad_resize",
      "offer": "Flat 5% Off",
      "description": "On Entire Range"
    },
    {
      "img": "https://images-static.nykaa.com/creatives/b053fa2e-4580-4fc2-8362-72d9ea1cd5ec/default.jpeg?tr=w-240,cm-pad_resize",
      "offer": "Up To 40% Off",
      "description": "On Entire Range"
    },
    {
      "img": "https://images-static.nykaa.com/creatives/83f040e1-7dd3-4c21-bd16-dea71d791cbc/default.jpg?tr=w-240,cm-pad_resize",
      "offer": "Drench the Lip",
      "description": "in Sheer Hydration!"
    },
    {
      "img": "https://images-static.nykaa.com/creatives/39bdb712-55b0-417f-a85a-9dd2d1b6d1dc/default.jpg?tr=w-240,cm-pad_resize",
      "offer": "Upto 30% Off",
      "description": "On Entire Range!"
    },
    {
      "img": "https://images-static.nykaa.com/uploads/652c303a-d60a-4bb8-91bb-bdae32a19fa6.jpg?tr=w-240,cm-pad_resize",
      "offer": "Award Winning",
      "description": "Root Treatment Oil!"
    },
    {
      "img": "https://images-static.nykaa.com/uploads/432fab36-c5f8-48fd-8d44-d95f497e513d.jpg?tr=w-240,cm-pad_resize",
      "offer": "On ₹3000:",
      "description": "Complexion Stick"
    }
  ]
  
  export const lakmeCar=[
    {img:"https://images-static.nykaa.com/uploads/da5789a8-100b-440a-8fde-93e20b1e0970.jpg?tr=w-600,cm-pad_resize"},
    {img:"https://images-static.nykaa.com/uploads/4811264e-3b2f-4346-9fb3-78848bd3e53d.jpg?tr=w-600,cm-pad_resize"},
    {img:"https://images-static.nykaa.com/uploads/f2ee4a23-fa89-4ac4-81cb-9c3b0d34824b.jpg?tr=w-600,cm-pad_resize"},
    {img:"https://images-static.nykaa.com/uploads/2b9cacca-0608-4d90-9060-0c40bd950f50.jpg?tr=w-600,cm-pad_resize"},
    {img:"https://images-static.nykaa.com/uploads/4811264e-3b2f-4346-9fb3-78848bd3e53d.jpg?tr=w-600,cm-pad_resize"},
    {img:"https://images-static.nykaa.com/uploads/2b9cacca-0608-4d90-9060-0c40bd950f50.jpg?tr=w-600,cm-pad_resize"},
    {img:"https://images-static.nykaa.com/uploads/f2ee4a23-fa89-4ac4-81cb-9c3b0d34824b.jpg?tr=w-600,cm-pad_resize"},

]

export const lakmeCat=[
  {img:"https://images-static.nykaa.com/uploads/f7e7bf26-c95a-44e8-8983-3c239a9e9358.jpg?tr=w-240,cm-pad_resize"},
  {img:"https://images-static.nykaa.com/uploads/995d5502-7ec0-4f1b-b295-195d0d54ca5a.jpg?tr=w-240,cm-pad_resize"},
  {img:"https://images-static.nykaa.com/uploads/5695c301-2486-45ec-a861-599b89d9bf2e.jpg?tr=w-240,cm-pad_resize"},
  {img:"https://images-static.nykaa.com/uploads/6dce1f44-6023-445d-8764-c0e0de9c359d.jpg?tr=w-240,cm-pad_resize"},
  {img:"https://images-static.nykaa.com/uploads/6c19503a-cbd8-4c80-82bb-6d3aa2b470b9.jpg?tr=w-240,cm-pad_resize"},
  {img:"https://images-static.nykaa.com/uploads/dd16bd4c-04c4-4810-b023-12815dbcba13.jpg?tr=w-240,cm-pad_resize"},
{img:"https://images-static.nykaa.com/uploads/b94483d1-d4ee-4021-95a8-7af37a7ed4a2.jpg?tr=w-240,cm-pad_resize"}
]


/*export const lakmelooks=[
  {img:""},
  {img:""},
  {img:""},
  {img:""},
  {img:""},
  {img:""},

]*/

export const lakme=[
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/9/d/9d846d129657_H-8901030973727.jpg",
      "name": "Lakme Glitterati Collection Shine Eyeliner",
      "mrp": "₹550",
      "price": "₹495",
      "offer": "10% Off",
      "shades": "5 shades",
      "qty": ""
    },
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/a/b/abffdf38901030968716_1.jpg",
      "name": "Lakme Absolute Explore Eye Paint",
      "mrp": "₹550",
      "price": "₹523",
      "offer": "5% Off",
      "shades": "7 shades",
      "qty": "( 1 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/8/2807eca22769_H_8901030366086.jpg",
      "name": "Lakme Absolute Skin Natural Mousse Mattreal Foundation",
      "mrp": "₹875",
      "price": "₹656",
      "offer": "25% Off",
      "shades": "6 shades",
      "qty": "( 32316 )"
    },
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/9/d/9d846d129671_H-8901030974182.jpg",
      "name": "Lakme Glitterati Collection Shine Lipstick",
      "mrp": "₹650",
      "price": "₹585",
      "offer": "10% Off",
      "shades": "10 shades",
      "qty": ""
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/f/4/f4ed626LAKME00000467.jpg",
      "name": "Lakme Eyeconic Power Pack Combo",
      "mrp": "₹1139",
      "price": "₹968",
      "offer": "15% Off",
      "shades": "",
      "qty": "( 29618 )"
    },
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/a/b/abffdf38901030971099_1.jpg",
      "name": "Lakme Absolute Luminous Skin Tint Foundation",
      "mrp": "₹875",
      "price": "₹788",
      "offer": "10% Off",
      "shades": "6 shades",
      "qty": ""
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/0/203fa44LAKME00000889.jpg",
      "name": "Lakme Eyeconic Kajal",
      "mrp": "₹275",
      "price": "₹228",
      "offer": "17% Off",
      "shades": "9 shades",
      "qty": "( 30740 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/8/2807eca24452_H_8901030742446.jpg",
      "name": "Lakme 9 To 5 Primer + Matte Perfect Cover Foundation",
      "mrp": "₹525",
      "price": "₹404",
      "offer": "23% Off",
      "shades": "20 shades",
      "qty": "( 29135 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/8/2807eca23657_H_8901030824999.jpg",
      "name": "Lakme Absolute Primer",
      "mrp": "₹825",
      "price": "₹701",
      "offer": "15% Off",
      "shades": "3 shades",
      "qty": "( 394 )"
    },
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/9/d/9d846d129680_H-8901030975004.jpg",
      "name": "Lakme Glitterati Collection Nail Polish",
      "mrp": "₹225",
      "price": "₹203",
      "offer": "10% Off",
      "shades": "12 shades",
      "qty": ""
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/4/4/44ee98f29405_H-8901030919237.jpg",
      "name": "Lakme Absolute Explore Eye Shadow Palette",
      "mrp": "₹995",
      "price": "₹796",
      "offer": "20% Off",
      "shades": "2 shades",
      "qty": "( 55 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/d/3/d3e3c4fLAKME00000476_1.jpg",
      "name": "Lakme Primer + Matte Face Base Medium Combo",
      "mrp": "₹1575",
      "price": "₹1103",
      "offer": "30% Off",
      "shades": "",
      "qty": "( 26052 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/8/2807eca24859_H_8901030794773.jpg",
      "name": "Lakme 9 To 5 Primer + Matte Lipstick",
      "mrp": "₹550",
      "price": "₹468",
      "offer": "15% Off",
      "shades": "35 shades",
      "qty": "( 35067 )"
    },
    {
      "featured": "",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/2/8/2807eca24551_H_8901030758942.jpg",
      "name": "Lakme Forever Matte Liquid Lip Color",
      "mrp": "₹349",
      "price": "₹314",
      "offer": "10% Off",
      "shades": "50 shades",
      "qty": "( 75428 )"
    },
    {
      "featured": "",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/9/9/994f68922998_S1_8901030863127.jpg",
      "name": "Lakme Complexion Care Face CC Cream",
      "mrp": "₹360",
      "price": "₹324",
      "offer": "10% Off",
      "shades": "6 shades",
      "qty": "( 44272 )"
    },
    {
      "featured": "",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/1/7/17def8f27512_H-8901030978975.jpg",
      "name": "Lakme Lumi Skin Cream",
      "mrp": "₹299",
      "price": "₹269",
      "offer": "10% Off",
      "shades": "2 sizes",
      "qty": "( 27310 )"
    },

  ]

  export const sidebar=[
    {
      "title": "Price"
    },
    {
      "title": "Category"
    },
    {
      "title": "Discount"
    },
    {
      "title": "Color"
    },
    {
      "title": "Skin type"
    },
    {
      "title": "Concern"
    },
    {
      "title": "Formulation"
    },
    {
      "title": "Finish"
    },
    {
      "title": "Avg Customer Rating"
    },
    {
      "title": "Country Of Origin"
    },
    {
      "title": "Gender"
    },
    {
      "title": "Preference"
    },
    {
      "title": "Coverage"
    },
    {
      "title": "Benefits"
    },
    {
      "title": "SPF"
    },
    {
      "title": "Skin tone"
    }
  ]

  export const nykaaNaturals=[
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/5/b/5b7a2eb890424570485_1.jpg",
      "name": "Nykaa Naturals Skin Secrets Bestseller Sheet Mask - Monthly ...",
      "mrp": "₹500",
      "price": "₹350",
      "offer": "30% Off",
      "qty": "( 335 )",
      "gift": ""
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/a/4/a447697NYKAB00000568-New1.jpg",
      "name": "Nykaa Naturals Fermented Rice Water & Bamboo Shampoo & Condi...",
      "mrp": "₹798",
      "price": "₹662",
      "offer": "17% Off",
      "qty": "( 1546 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/0/f/0ffc7cb8904245710460_1.jpg",
      "name": "Nykaa Clay It Cool Perfect Glow Clay Mask",
      "mrp": "₹599",
      "price": "₹569",
      "offer": "5% Off",
      "qty": "( 13686 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/5/a/5a7f88bNYKAB00000248_1k.jpg",
      "name": "Nykaa Scalp Massager Brush For Blood Circulation & Natural H...",
      "mrp": "",
      "price": "₹499",
      "offer": "",
      "qty": "( 2220 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/e/e/ee7372bNYKAB00000327_1.jpg",
      "name": "Nykaa Skin Secrets Gold Sheet Mask + Nykaa Skin Potion 24k G...",
      "mrp": "₹1099",
      "price": "₹912",
      "offer": "17% Off",
      "qty": "( 62 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/d/c/dc6ec738904245714659_1.jpg",
      "name": "Nykaa Naturals Microfiber Hair Wrap for Frizz Free & Shiny H...",
      "mrp": "₹499",
      "price": "₹474",
      "offer": "5% Off",
      "qty": "( 4776 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Nykaa Naturals Hair Growth Combo",
      "mrp": "₹798",
      "price": "₹742",
      "offer": "7% Off",
      "qty": "( 2958 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Nykaa Tea Tree & Salicylic Acid Spot Patch for Pimple Care -...",
      "mrp": "₹500",
      "price": "₹475",
      "offer": "5% Off",
      "qty": "( 18459 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "",
      "name": "Nykaa Naturals Festive Glow Sheet Mask Combo - Pack Of 3",
      "mrp": "₹300",
      "price": "₹225",
      "offer": "25% Off",
      "qty": "( 41525 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Nykaa Naturals Rosemary Essential Oil for Hair Growth and Sc...",
      "mrp": "",
      "price": "₹350",
      "offer": "",
      "qty": "( 149 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "",
      "name": "Nykaa Naturals Saffron & Honey Face Wash for Glowing Skin",
      "mrp": "₹139",
      "price": "₹90",
      "offer": "35% Off",
      "qty": "( 41149 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "",
      "name": "Nykaa Naturals Sheet Mask Combo For Deep Hydration - Pack Of...",
      "mrp": "₹300",
      "price": "₹225",
      "offer": "25% Off",
      "qty": "( 200178 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Nykaa Naturals Saffron & Honey Face Scrub for Glowing Skin",
      "mrp": "₹249",
      "price": "₹199",
      "offer": "20% Off",
      "qty": "( 7649 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Nykaa Face Massage Rollers - Rose Quartz",
      "mrp": "₹1999",
      "price": "₹1699",
      "offer": "15% Off",
      "qty": "( 1452 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "",
      "name": "Nykaa Naturals Anti-ageing Sheet Mask Combo - Pack Of 3",
      "mrp": "₹300",
      "price": "₹225",
      "offer": "25% Off",
      "qty": "( 200182 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "",
      "name": "Nykaa Naturals Pre-makeup Skincare Sheet Mask Combo - Pack O...",
      "mrp": "₹300",
      "price": "₹225",
      "offer": "25% Off",
      "qty": "( 15728 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Nykaa Naturals Gua Sha Stone - Rose Quartz",
      "mrp": "₹1999",
      "price": "₹1299",
      "offer": "35% Off",
      "qty": "( 991 )",
      "gift": "Enjoy Free Gift"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Nykaa Skin Secrets Charcoal Bubble Sheet Mask",
      "mrp": "₹199",
      "price": "₹159",
      "offer": "20% Off",
      "qty": "( 1446 )",
      "gift": "Or Buy 1 at MRP, Get 1 Free"
    },
    {
      "featured": "",
      "best": "BESTSELLER",
      "img": "",
      "name": "Nykaa Naturals Skin Secrets Exotic Indulgence Sheet Mask",
      "mrp": "₹100",
      "price": "₹80",
      "offer": "20% Off",
      "qty": "( 200160 )",
      "gift": "Or Buy 5 at MRP, Get 5 Free"
    },
    {
      "featured": "",
      "best": "BESTSELLER",
      "img": "",
      "name": "Nykaa Naturals Skin Secrets Indian Rituals Sheet Mask",
      "mrp": "₹100",
      "price": "₹80",
      "offer": "20% Off",
      "qty": "( 41471 )",
      "gift": "Or Buy 5 at MRP, Get 5 Free"
    }
  ]

  export const kaybeauty=[
    {
      "featured": "FEATURED",
      "best": "NEW",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/f/f/ff2ddffKAYBE00000225_1.jpg",
      "name": "Kay Beauty Lip Tint",
      "mrp": "₹899",
      "price": "₹809",
      "offer": "10% Off",
      "shades": "8 shades",
      "qty": ""
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/c/4/c4da1f6KAYBE00000049_01.jpg",
      "name": "Kay Beauty Gel Eye Pencil",
      "mrp": "₹625",
      "price": "₹375",
      "offer": "40% Off",
      "shades": "7 shades",
      "qty": "( 3583 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/c/4/c4da1f6KAYBE00000054_01.jpg",
      "name": "Kay Beauty Creme Blush",
      "mrp": "₹799",
      "price": "₹519",
      "offer": "35% Off",
      "shades": "5 shades",
      "qty": "( 7562 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/e/x/exotic-indigo_1.jpg",
      "name": "Kay Beauty Quick Dry Liquid Eyeliner",
      "mrp": "₹599",
      "price": "₹359",
      "offer": "40% Off",
      "shades": "8 shades",
      "qty": "( 13324 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/8/1/81671cf8904330902510_1.jpg",
      "name": "Kay Beauty Hydrating Foundation",
      "mrp": "₹1200",
      "price": "₹720",
      "offer": "40% Off",
      "shades": "17 shades",
      "qty": "( 8478 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "https://images-static.nykaa.com/media/catalog/product/tr:w-220,h-220,cm-pad_resize/8/9/8904330901445_1.jpg",
      "name": "Kay Beauty Matte Drama Long Stay Lipstick",
      "mrp": "₹999",
      "price": "₹599",
      "offer": "40% Off",
      "shades": "23 shades",
      "qty": "( 5772 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "",
      "name": "Kay Beauty Kohlstar 24 Hour Kajal - Spade",
      "mrp": "₹299",
      "price": "₹179",
      "offer": "40% Off",
      "shades": "",
      "qty": "( 862 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Hydrating Lip Oil Gloss (Hydrate & Treat)",
      "mrp": "",
      "price": "₹899",
      "offer": "",
      "shades": "",
      "qty": "( 122 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "",
      "name": "Kay Beauty Matte Liquid Lipstick",
      "mrp": "",
      "price": "₹1200",
      "offer": "",
      "shades": "12 shades",
      "qty": "( 596 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Eyeshadow Palette - Carefree",
      "mrp": "₹1199",
      "price": "₹719",
      "offer": "40% Off",
      "shades": "5 shades",
      "qty": "( 3397 )"
    },
    {
      "featured": "FEATURED",
      "best": "BESTSELLER",
      "img": "",
      "name": "Kay Beauty Matteinee Matte Lip Crayon Lipstick",
      "mrp": "₹849",
      "price": "₹509",
      "offer": "40% Off",
      "shades": "14 shades",
      "qty": "( 15123 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Hd Liquid Concealer",
      "mrp": "₹849",
      "price": "₹509",
      "offer": "40% Off",
      "shades": "9 shades",
      "qty": "( 2991 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Matte Blush",
      "mrp": "₹899",
      "price": "₹539",
      "offer": "40% Off",
      "shades": "8 shades",
      "qty": "( 6565 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Illuminating Highlighter",
      "mrp": "₹899",
      "price": "₹629",
      "offer": "30% Off",
      "shades": "6 shades",
      "qty": "( 4170 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Nail Nourish Nail Enamel Polish",
      "mrp": "₹259",
      "price": "₹155",
      "offer": "40% Off",
      "shades": "36 shades",
      "qty": "( 24533 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Contour Stick",
      "mrp": "₹725",
      "price": "₹435",
      "offer": "40% Off",
      "shades": "3 shades",
      "qty": "( 7484 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Matte Action Lip Liner",
      "mrp": "₹599",
      "price": "₹359",
      "offer": "40% Off",
      "shades": "7 shades",
      "qty": "( 6945 )"
    },
    {
      "featured": "FEATURED",
      "best": "",
      "img": "",
      "name": "Kay Beauty Metallic Eyeshadow Stick Pencil",
      "mrp": "₹749",
      "price": "₹524",
      "offer": "30% Off",
      "shades": "12 shades",
      "qty": "( 8240 )"
    },
    {
      "featured": "",
      "best": "",
      "img": "",
      "name": "Kay Beauty Matte HD Setting Loose Powder",
      "mrp": "₹799",
      "price": "₹519",
      "offer": "35% Off",
      "shades": "8 shades",
      "qty": "( 7630 )"
    },
    {
      "featured": "",
      "best": "",
      "img": "",
      "name": "Kay Beauty Matte Compact",
      "mrp": "₹849",
      "price": "₹594",
      "offer": "30% Off",
      "shades": "10 shades",
      "qty": "( 5149 )"
    }
  ]